import React from 'react';

const LoadingSpinnerButton = ({className}) => {
  return (
        <div className={className}></div>
  );
};

export default LoadingSpinnerButton;